import { Ban, ShieldOff, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { BlockedIpRow, SecurityEventRow } from "@/components/security/SecurityParts";

const field = "h-9 rounded-md border border-[#22252F] bg-[#0F1116] px-2 text-xs text-white";

export const SecurityEventsTab = ({ events, blockedSet, onClear, onBlock }) => (
  <div className="space-y-3">
    <div className="flex flex-wrap items-center gap-2">
      <Button data-testid="clear-events-30" onClick={() => onClear(30)}
              className="h-8 rounded-md border border-[#22252F] bg-transparent px-3 text-xs text-[#94A3B8] hover:border-[#2563EB] hover:text-white">
        Limpar com +30 dias
      </Button>
      <Button data-testid="clear-events-all" onClick={() => onClear(0)}
              className="h-8 rounded-md bg-[#EF4444] px-3 text-xs hover:bg-[#DC2626]">
        <Trash2 className="mr-1.5 h-3 w-3" /> Limpar histórico
      </Button>
    </div>
    <div className="max-h-72 space-y-1 overflow-y-auto" data-testid="security-events-list">
      {events.length === 0 ? (
        <p className="text-sm text-[#94A3B8]">Sem eventos registados.</p>
      ) : events.map((e, i) => (
        <SecurityEventRow key={`${e.created_at}-${i}`} event={e}
                          blocked={blockedSet.has(e.identifier)}
                          onBlock={() => onBlock(e.identifier)} />
      ))}
    </div>
  </div>
);

export const BlockedIpsTab = ({ blocked, manual, onManualChange, onSubmit, onUnblock }) => (
  <div className="space-y-3">
    <p className="flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#94A3B8]">
      <ShieldOff className="h-3.5 w-3.5" /> Lista negra de IPs ({blocked.length})
    </p>
    <form className="flex flex-wrap gap-2" onSubmit={onSubmit}>
      <Input data-testid="manual-ip-input" value={manual.ip}
             onChange={(e) => onManualChange({ ...manual, ip: e.target.value })}
             placeholder="IP ou intervalo: 203.0.113.0/24" className={`${field} w-56 font-mono`} />
      <Input data-testid="manual-ip-note" value={manual.note}
             onChange={(e) => onManualChange({ ...manual, note: e.target.value })}
             placeholder="Nota (opcional)" className={`${field} flex-1 min-w-[10rem]`} />
      <Button data-testid="manual-block-ip" type="submit" disabled={!manual.ip.trim()}
              className="h-9 rounded-md bg-[#EF4444] px-4 text-xs uppercase tracking-[0.15em] hover:bg-[#DC2626]">
        <Ban className="mr-1.5 h-3 w-3" /> Bloquear IP
      </Button>
    </form>
    <div data-testid="blocked-ips-list" className="max-h-72 space-y-1 overflow-y-auto">
      {blocked.length === 0 ? (
        <p className="text-sm text-[#94A3B8]">Nenhum IP bloqueado.</p>
      ) : blocked.map((b) => (
        <BlockedIpRow key={b.ip} entry={b} onUnblock={() => onUnblock(b.ip)} />
      ))}
    </div>
  </div>
);
